export const isNullOrUndefined = (v: any) : v is null | undefined => v === undefined || v === null;